export const colors = {
  primary: `#FB6910`,
  secondary: `#343233`,
  tertiary: `#E8E8E8`,
  background: {
    1: `#FFFFFF`,
    2: `#F6F6F7`,
    3: ` #f5f6fa`,
  },
  red: `#E72424`,
  green: `#15b138`,
  black: {
    1: `#161616`,
  },
  gray: {
    1: `rgb(106, 108, 114)`,
    2: `#494d4b`,
  },
};
